export default __webpack_public_path__ + "static/media/surgeryTracker.b121babd.png";